// extracted by css-extract-rspack-plugin
export default {"root":"root-IUW5QT","item":"item-zLN4tQ"};